import { z } from "zod"

import { ListSchema } from "./list"
import { EmailSchema } from "./email"
import { SegmentSchema } from "./segment"

export const NewsletterSchema = z.object({
  id: z.number(),
  name: z.string(),
  wants_send_email: z.boolean(),
  email_id: z.number().nullable(),
  email_list_id: z.number().nullable(),
  email_segment_id: z.string().nullable(),
  wants_exclude_email_segment: z.boolean(),
  project_id: z.number(),
  sent_at: z.string().nullable(),
  status: z.enum(["draft", "sending", "sent", "failed"]),
  email_status: z.enum(["draft", "sending", "sent", "failed"]),
  push_status: z.enum(["draft", "sending", "sent", "failed"]),
  count_recipients: z.number(),
  count_sent: z.number(),
  count_failed: z.number(),
  wants_send_push: z.boolean(),
  push_title: z.string().nullable(),
  push_content: z.string().nullable(),
  push_list_id: z.number().nullable(),
  push_segment_id: z.string().nullable(),
  wants_exclude_push_segment: z.boolean(),
  push_count_recipients: z.number(),
  push_count_sent: z.number(),
  push_count_failed: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  email: EmailSchema.optional().nullable(),
  email_list: ListSchema.optional().nullable(),
  push_list: ListSchema.optional().nullable(),
  email_segment: SegmentSchema.optional().nullable(),
  push_segment: SegmentSchema.optional().nullable(),
})
